"use client";

import { AnimatedItem } from "@/components/componentAnimation/animatedItemComponent";
import sharedStyles from "../shared/SectionTitle.module.css";
import styles from "./AccommodationIntro.module.css";

type AccommodationIntroProps = {
  title: string;
  description: string;
};

export default function AccommodationIntro({
  title,
  description,
}: AccommodationIntroProps) {
  return (
    <AnimatedItem>
      <section className={styles.introSection}>
        <h2 className={sharedStyles.sectionTitle}>{title}</h2>

        <div className={styles.introBox}>
          <p className={styles.introText}>{description}</p>
        </div>
      </section>
    </AnimatedItem>
  );
}
